import { type ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { useGroupMessageReaders } from '@/contexts/chat/scripts/hooks/useChatGroup/hooks';
import ReadProcess from '../read-process';
import classes from './index.module.scss';

export interface GroupMessageStatusProps {
  className?: ClassNames;
  message: ChatMessage;
}

export default function GroupMessageStatus({
  className,
  message,
}: GroupMessageStatusProps) {
  const { readerIds, receiverIds } = useGroupMessageReaders({ message });

  const process = useMemo(() => {
    return receiverIds.length > 0 ? readerIds.length / receiverIds.length : 0;
  }, [readerIds.length, receiverIds.length]);

  return (
    <span className={cls(classes.groupMessageStatus, className)}>
      <ReadProcess process={process} />
    </span>
  );
}
